import { render } from "./ErrorView.vue?vue&type=template&id=34bf6949&scoped=true"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"

import "./ErrorView.vue?vue&type=style&index=0&id=34bf6949&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bf6949"]])

export default __exports__